import { Button } from 'components/Button/Button';
import {
  LegacyDropdown,
  LegacyDropdownPlacement,
} from 'components/LegacyDropdown';
import { ListingType } from 'types/ListingType';
import { OrgType } from 'utils/constants/general/orgTypes';

import { StyledMenuContainer } from './ListingActionsDropdown.styled';
import { ReportListingMenuItem } from './ReportListingMenuItem';
import { SaveOrgMenuItem } from './SaveOrgMenuItem';
import { ShareMenuItem } from './ShareMenuItem';

function ThreeDots(_open: boolean, tabIndex?: number) {
  return (
    <Button
      icon={{ type: 'normalized', name: '3-dots' }}
      variant="secondary"
      tabIndex={tabIndex}
    />
  );
}

type Props = {
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  orgId?: string;
  orgName?: string;
  orgType?: OrgType;
  mobilePlacement?: LegacyDropdownPlacement;
  placement?: LegacyDropdownPlacement;
  tabIndex?: number;
};

export function ListingActionsDropdown({
  listingId,
  listingType,
  listingUrl,
  orgId,
  orgType,
  orgName,
  mobilePlacement,
  placement,
  tabIndex,
}: Props) {
  return (
    <LegacyDropdown
      tabIndex={tabIndex}
      aria-label={getText('View more actions')}
      data-qa-id="listings-more-actions"
      title={ThreeDots}
      mobilePlacement={mobilePlacement || 'right'}
      placement={placement || 'right'}
      menuMarginLeft={32}
      hideCloseTrigger
      noTriggerPadding
      unstyled
      render={({ closeMenu }) => (
        <StyledMenuContainer>
          <ShareMenuItem
            closeMenu={closeMenu}
            mobileOnly
            listingId={listingId}
            listingType={listingType}
            listingUrl={listingUrl}
            orgId={orgId}
          />
          {orgId && orgName && orgType ? (
            <SaveOrgMenuItem
              closeMenu={closeMenu}
              orgId={orgId}
              orgName={orgName}
              orgType={orgType}
            />
          ) : null}
          <ReportListingMenuItem
            closeMenu={closeMenu}
            listingId={listingId}
            listingType={listingType}
          />
        </StyledMenuContainer>
      )}
    />
  );
}
